import apiConfig from './config';
import helper from '../../utils/helper';

const enviarCorreoDeuda = (data, success, error) => {
    const token = helper.getToken();
    return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/generar-pdf-deuda/${data.id}?user_name=${data.user_name}&user_id=${data.user_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(apiConfig.methods.checkStatus)
      .then(apiConfig.methods.parseJSON)
      .then(success)
      .catch(apiConfig.methods.error)
      .then(error);
};


const exportedObject = {
  enviarCorreoDeuda,
};

export default exportedObject;
